export default __webpack_public_path__ + "static/media/content_tab02_02.f12a2908.png";